import {MessageDetails} from '../types';
import {selectCompanyStore} from '../../SelectCompanyDlg/SelectCompanyStore';
import {isRTL} from '../../../Localization';
import {getGMTtime, getGMTdiff, getIntlDateTimeFormat} from '../../../Localization/date';

const testEnvUrl = 'https://t.eu.priority-connect.online/webui/';
const releaseNotesUrlEn = 'https://support.priority-software.com/en/kb/LBI2500143/English';
const releaseNotesUrlHe = 'https://s3.priority-software.com/webapps/release/index.html';

export const cookieName = 'upgradeDialogShown';

export const getUpgradeDateString = (details: MessageDetails) => {
    const {VersionNum, upgradeDate, hour} = details;

    if (isRTL()) {
        return `מערכת Priority עומדת להשתדרג לגרסה ${VersionNum}.\nמועד השדרוג נקבע ל ${getIntlDateTimeFormat(
            upgradeDate
        )} בשעה ${hour}.`;
    } else {
        const gmtDiff = getGMTdiff();
        const gmtHour = getGMTtime(hour, gmtDiff);

        return `Your Priority system will be upgraded to version ${VersionNum} on ${getIntlDateTimeFormat(
            upgradeDate
        )} at ${gmtHour} GMT.`;
    }
};

export const getTestEnvUrl = () => {
    const prettyName = selectCompanyStore.getPrettyName();
    return testEnvUrl + prettyName;
};

export const getReleaseNotesUrl = () => {
    const isHebrew = isRTL();
    return isHebrew ? releaseNotesUrlHe : releaseNotesUrlEn;
};
